"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SNUserPrefs = void 0;
const domain_core_1 = require("@standardnotes/domain-core");
const DecryptedItem_1 = require("../../Abstract/Item/Implementations/DecryptedItem");
const Predicate_1 = require("../../Runtime/Predicate/Predicate");
class SNUserPrefs extends DecryptedItem_1.DecryptedItem {
    get isSingleton() {
        return true;
    }
    singletonPredicate() {
        return SNUserPrefs.singletonPredicate;
    }
    getPref(key) {
        return this.getAppDomainValue(key);
    }
}
exports.SNUserPrefs = SNUserPrefs;
SNUserPrefs.singletonPredicate = new Predicate_1.Predicate('content_type', '=', domain_core_1.ContentType.TYPES.UserPrefs);
